import { Theme } from '@emotion/react';
import { BaseColorsClassKey } from '@futrli/colors';
import { Switch, SwitchProps } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { omit } from 'lodash';
import React, { FC } from 'react';

export interface UISwitchOwnProps {
  /**
   * A custom @FUTRLI color.
   */
  customColor?: BaseColorsClassKey;
  colorThumb?: string;
  colorTrack?: string;
}

export type UISwitchProps = UISwitchOwnProps & Omit<SwitchProps, keyof UISwitchOwnProps>;

const useStyles = makeStyles<Theme, UISwitchProps>(() =>
  createStyles({
    switchBase: props => {
      return {
        'padding': '10px !important',
        '&:hover': {
          backgroundColor: 'transparent'
        },
        'color': '#9196A4',

        '& .MuiSwitch-thumb': {
          boxSizing: 'border-box',
          width: 12,
          height: 12,
          margin: 3
        },

        '& + $track': {
          backgroundColor: '#D2DAEB'
        },
        '&$checked': {
          color: props.colorThumb || '#41CAA7'
        },
        '&$checked + $track': {
          backgroundColor: props.colorTrack || 'rgba(104, 198, 171, 0.5)'
        },
        '&$disabled': {
          opacity: 0.5
        }
      };
    },
    checked: () => ({}),
    track: () => ({}),
    disabled: () => ({})
  })
);
/**
 * Wraps the Material UI Switch and applies the whitelabelling.
 */
export const UISwitch: FC<UISwitchProps> = props => {
  const { color = 'default', ...rest } = props;

  const uiClasses = useStyles(props);
  const muiProps = omit(rest, ['customColor', 'colorThumb', 'colorTrack']);

  return (
    <Switch
      {...muiProps}
      color={color}
      classes={uiClasses}
      inputProps={{
        'aria-label': 'switch'
      }}
    />
  );
};
